export { default as ScreenRecording } from './RenderScreenRecording';
